import { render } from "./QuizesList.vue?vue&type=template&id=e30e04a4&scoped=true"
import script from "./QuizesList.vue?vue&type=script&lang=js"
export * from "./QuizesList.vue?vue&type=script&lang=js"

import "./QuizesList.vue?vue&type=style&index=0&id=e30e04a4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e30e04a4"]])

export default __exports__